import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedUserGuard, LoginGuard } from '@ideapa/app-auth';
import {
  CheckChiusuraEsercizioGuard,
  CheckConsolidatoGuard,
  CheckDatiRiepilogoModificatiGuard,
} from '@ideapa/app/check-bilanci';
import { LoadUnreadNotificationsGuard } from '@ideapa/app/notifications';

import { TabLayoutComponent } from './containers/layout/tab-layout.component';
import { ModalComponent } from './containers/modal/modal.component';
import { allRoutes } from './routes';

export const entityRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  ...allRoutes,
];

const appRoutes: Routes = [
  {
    path: '',
    canActivate: [LoginGuard],
    children: [
      {
        path: '',
        component: TabLayoutComponent,
        canActivate: [
          LoggedUserGuard,
          LoadUnreadNotificationsGuard,
          CheckChiusuraEsercizioGuard,
          CheckConsolidatoGuard,
          CheckDatiRiepilogoModificatiGuard,
        ],
        runGuardsAndResolvers: 'always',
        children: entityRoutes,
      },
      {
        path: 'modal',
        component: ModalComponent,
        canActivate: [
          LoggedUserGuard,
          CheckConsolidatoGuard,
          CheckChiusuraEsercizioGuard,
          CheckDatiRiepilogoModificatiGuard,
        ],
        children: entityRoutes,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
